/**
 * Maps country names (from Google Places) to ISO currency codes.
 * This is a simplified mapping for common regions.
 */
export const countryToCurrency: Record<string, string> = {
  'United Arab Emirates': 'AED',
  'Afghanistan': 'AFN',
  'Albania': 'ALL',
  'Armenia': 'AMD',
  'Angola': 'AOA',
  'Argentina': 'ARS',
  'Australia': 'AUD',
  'Azerbaijan': 'AZN',
  'Bosnia and Herzegovina': 'BAM',
  'Barbados': 'BBD',
  'Bangladesh': 'BDT',
  'Bulgaria': 'BGN',
  'Bahrain': 'BHD',
  'Burundi': 'BIF',
  'Bermuda': 'BMD',
  'Brunei': 'BND',
  'Bolivia': 'BOB',
  'Brazil': 'BRL',
  'Bahamas': 'BSD',
  'Bhutan': 'BTN',
  'Botswana': 'BWP',
  'Belarus': 'BYN',
  'Belize': 'BZD',
  'Canada': 'CAD',
  'Democratic Republic of the Congo': 'CDF',
  'Switzerland': 'CHF',
  'Chile': 'CLP',
  'China': 'CNY',
  'Colombia': 'COP',
  'Costa Rica': 'CRC',
  'Cuba': 'CUP',
  'Cape Verde': 'CVE',
  'Czechia': 'CZK',
  'Djibouti': 'DJF',
  'Denmark': 'DKK',
  'Dominican Republic': 'DOP',
  'Algeria': 'DZD',
  'Egypt': 'EGP',
  'Eritrea': 'ERN',
  'Ethiopia': 'ETB',
  'Euro Area': 'EUR',
  'France': 'EUR',
  'Germany': 'EUR',
  'Italy': 'EUR',
  'Spain': 'EUR',
  'Netherlands': 'EUR',
  'Belgium': 'EUR',
  'Greece': 'EUR',
  'Portugal': 'EUR',
  'Austria': 'EUR',
  'Finland': 'EUR',
  'Ireland': 'EUR',
  'Fiji': 'FJD',
  'Falkland Islands': 'FKP',
  'United Kingdom': 'GBP',
  'Georgia': 'GEL',
  'Guernsey': 'GGP',
  'Ghana': 'GHS',
  'Gibraltar': 'GIP',
  'Gambia': 'GMD',
  'Guinea': 'GNF',
  'Guatemala': 'GTQ',
  'Guyana': 'GYD',
  'Hong Kong': 'HKD',
  'Honduras': 'HNL',
  'Croatia': 'EUR', // Croatia joined Eurozone
  'Haiti': 'HTG',
  'Hungary': 'HUF',
  'Indonesia': 'IDR',
  'Israel': 'ILS',
  'Isle of Man': 'IMP',
  'India': 'INR',
  'Iraq': 'IQD',
  'Iran': 'IRR',
  'Iceland': 'ISK',
  'Jersey': 'JEP',
  'Jamaica': 'JMD',
  'Jordan': 'JOD',
  'Japan': 'JPY',
  'Kenya': 'KES',
  'Kyrgyzstan': 'KGS',
  'Cambodia': 'KHR',
  'Kiribati': 'KID',
  'Comoros': 'KMF',
  'South Korea': 'KRW',
  'Kuwait': 'KWD',
  'Cayman Islands': 'KYD',
  'Kazakhstan': 'KZT',
  'Laos': 'LAK',
  'Lebanon': 'LBP',
  'Sri Lanka': 'LKR',
  'Liberia': 'LRD',
  'Lesotho': 'LSL',
  'Libya': 'LYD',
  'Morocco': 'MAD',
  'Moldova': 'MDL',
  'Madagascar': 'MGA',
  'North Macedonia': 'MKD',
  'Myanmar': 'MMK',
  'Mongolia': 'MNT',
  'Macau': 'MOP',
  'Mauritania': 'MRU',
  'Mauritius': 'MUR',
  'Maldives': 'MVR',
  'Malawi': 'MWK',
  'Mexico': 'MXN',
  'Malaysia': 'MYR',
  'Mozambique': 'MZN',
  'Namibia': 'NAD',
  'Nigeria': 'NGN',
  'Nicaragua': 'NIO',
  'Norway': 'NOK',
  'Nepal': 'NPR',
  'New Zealand': 'NZD',
  'Oman': 'OMR',
  'Panama': 'PAB',
  'Peru': 'PEN',
  'Papua New Guinea': 'PGK',
  'Philippines': 'PHP',
  'Pakistan': 'PKR',
  'Poland': 'PLN',
  'Paraguay': 'PYG',
  'Qatar': 'QAR',
  'Romania': 'RON',
  'Serbia': 'RSD',
  'Russia': 'RUB',
  'Rwanda': 'RWF',
  'Saudi Arabia': 'SAR',
  'Solomon Islands': 'SBD',
  'Seychelles': 'SCR',
  'Sudan': 'SDG',
  'Sweden': 'SEK',
  'Singapore': 'SGD',
  'Saint Helena': 'SHP',
  'Sierra Leone': 'SLL',
  'Somalia': 'SOS',
  'Suriname': 'SRD',
  'South Sudan': 'SSP',
  'São Tomé and Príncipe': 'STN',
  'Syria': 'SYP',
  'Eswatini': 'SZL',
  'Thailand': 'THB',
  'Tajikistan': 'TJS',
  'Turkmenistan': 'TMT',
  'Tunisia': 'TND',
  'Tonga': 'TOP',
  'Turkey': 'TRY',
  'Trinidad and Tobago': 'TTD',
  'Tuvalu': 'TVD',
  'Taiwan': 'TWD',
  'Tanzania': 'TZS',
  'Ukraine': 'UAH',
  'Uganda': 'UGX',
  'United States': 'USD',
  'Uruguay': 'UYU',
  'Uzbekistan': 'UZS',
  'Venezuela': 'VES',
  'Vietnam': 'VND',
  'Vanuatu': 'VUV',
  'Samoa': 'WST',
  'CFA Franc BEAC': 'XAF',
  'East Caribbean Dollar': 'XCD',
  'Special Drawing Rights': 'XDR',
  'CFA Franc BCEAO': 'XOF',
  'CFP Franc': 'XPF',
  'Yemen': 'YER',
  'South Africa': 'ZAR',
  'Zambia': 'ZMW',
  'Zimbabwe': 'ZWL',
};

export function getCurrencyFromLocation(location: string): string {
  if (!location) return 'USD';

  const parts = location.split(',').map(p => p.trim());

  // Search all segments right-to-left (country is usually last, but suburb
  // formats like "St Kilda East, Melbourne" may omit it)
  for (let i = parts.length - 1; i >= 0; i--) {
    if (countryToCurrency[parts[i]]) return countryToCurrency[parts[i]];
  }

  // Try to find if any country name appears as a substring
  for (const [c, cur] of Object.entries(countryToCurrency)) {
    if (location.includes(c)) return cur;
  }

  return 'USD';
}
